import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {NgbPaginationModule, NgbAlertModule, NgbDropdownItem, NgbDropdownModule, NgbAccordionModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgbPaginationModule,
    NgbAlertModule,
    NgbDropdownModule,
    NgbAccordionModule,
    NgbTooltipModule
  ],
  exports: [
    NgbPaginationModule,
    NgbAlertModule,
    NgbDropdownModule,
    NgbAccordionModule,
    NgbTooltipModule
  ]
})
export class BootstrapModule { }


